<script setup lang="ts">
import { ref } from "vue";
import Box from "../base/Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    text?: string;
    secondText?: string;
    startColor?: string;
    endColor?: string;
    dur?: number;
  }>(),
  {
    text: "",
    secondText: "",
    startColor: "#5A82F0",
    endColor: "#66B3FF",
    dur: 2000
  }
);

// const emits = defineEmits<{
//   (event: "click"): void;
// }>();

const ringGap = 10;
const ringWidth = 4;

const length = ref(0);
const resize = (box) => {
  length.value = Math.floor(Math.min(box.rect.width, box.rect.height));
};

defineExpose({});
</script>

<template>
  <Box
    display-type="full"
    @resize="resize"
  >
    <div
      class="ring"
      :style="{
        width: length + 'px',
        height: length + 'px',
        padding: ringGap + 'px',
        background: `linear-gradient(180deg, ${props.startColor} 0%, ${props.endColor} 100%)`
      }"
    >
      <div
        class="ring-rotate"
        :style="{
          animation: `rotate ${props.dur}ms infinite linear`,
          mask: `radial-gradient(transparent ${
            length / 2 - ringGap - ringWidth
          }px, #000 ${length / 2 - ringGap - ringWidth}px)`
        }"
      >
        <div class="left"></div>
        <div class="right"></div>
      </div>
      <div
        class="ring-content"
        :style="{
          top: ringGap + ringWidth + 'px',
          left: ringGap + ringWidth + 'px',
          width: length - (ringGap + ringWidth) * 2 + 'px',
          height: length - (ringGap + ringWidth) * 2 + 'px'
        }"
      >
        <div v-if="props.text">{{ props.text }}</div>
        <div v-if="props.secondText">{{ props.secondText }}</div>
      </div>
    </div>
  </Box>
</template>

<style>
/* @import "../../../../../css/animate_ce.css"; */
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style scoped>
.ring {
  position: relative;
  display: block;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  box-sizing: border-box;
}
.ring-rotate {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 50%;
}
.ring-content {
  position: absolute;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ring-content > div:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
}
.ring-content > div:nth-child(2) {
  font-size: 14px;
  margin-top: 6px;
}
.left,
.right {
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  z-index: 0;
}
.left {
  left: 0;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.5)
  );
}
.right {
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.5)
  );
}
</style>
